module.exports = __webpack_public_path__ + "static/brasil_junior-52f975efa5f528483a8b5b3ed645ec40.svg";